import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import REACT_APP from "../../environment";
import { toast } from "react-toastify";

export default function ActivityHotel({ id, setIsWaiting, in_hbp, name, getAllHotels, handleMenuClose }) {
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const openOperation = async () => {
        handleClose();
        setIsWaiting(true);
        await axios
            .post(
                `${REACT_APP.URL}/api/hdp/tts/adm/hotel/activite/${id}`,
                {},
                { headers: { Authorization: sessionStorage.getItem("token"), "client-id": REACT_APP.CLIENTID, "client-secret": REACT_APP.SECRET } }
            )
            .then((res) => {
                setIsWaiting(false);
                toast.success("Success", { autoClose: 2000 });
                handleMenuClose();
                getAllHotels();
                window.location.href= res.data.data
            })
            .catch((err) => {
                setIsWaiting(false);
                handleMenuClose();
                console.log(err);
                toast.error(err?.response?.data?.errors[0]?.message || "Something went wrong");
            });
    };

    return (
        <div>
            <Button onClick={handleClickOpen}>Activate hotel</Button>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Activate hotel</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Do you really want to activate the hotel yourself?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={openOperation}>Confirm</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
